





































import { Component, Vue, Prop } from 'vue-property-decorator';
import ButtonComponent from '@/shared/button/button.component.vue';

@Component({
  components: {
    ButtonComponent,
  },
})
export default class ModalConfirm extends Vue {
  @Prop() title!: string;

  @Prop() message!: string;

  @Prop() dialog!: boolean;

  cancel() {
    this.$emit('cancel');
  }

  confirm() {
    this.$emit('confirm');
  }
}
